import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import useAuth from "../../../auth/useAuth";
import Menu from "../../components/menu";
import Breadcrumbs from "../../components/breadcrumbs";
import "./styles.css";

// Каркас панели: сайдбар (бренд + меню) и основная колонка
// (шапка с заголовком и пользователем, прогресс, крошки, контент).
//
// На узком экране (<= 900px, см. styles.css) сайдбар превращается в выезжающую шторку:
// он занимает 220px из ~360px ширины телефона, то есть постоянно на экране ему места нет.
// Открывается «бургером» в шапке, закрывается кликом по затемнению и — обязательно — при
// смене маршрута: иначе после выбора пункта меню шторка так и висела бы поверх страницы,
// ради которой её открывали.
export default function Layout({ children }) {
    const title = useSelector((state) => state.app.title);
    const isLoad = useSelector((state) => state.app.isLoad);
    const { user, logout } = useAuth();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => { setIsMenuOpen(false); }, [location.pathname]);

    return <div className="layout">
        {isMenuOpen
            ? <div className="layout__overlay" onClick={() => setIsMenuOpen(false)}/>
            : null}
        <aside className={`layout__sidebar${isMenuOpen ? ' layout__sidebar_open' : ''}`}>
            <div className="layout__brand">Cloud Phone</div>
            <Menu/>
            {/* Пользователь и выход — низом шторки: на телефоне в шапке для них нет места
                (там бургер и заголовок), а в CSS одну и ту же кнопку в двух местах не
                переставить — она рисуется здесь и в шапке, лишняя скрыта по ширине. */}
            <div className="layout__sidebar-foot">
                <span className="layout__sidebar-user">{user ? user.name : ''}</span>
                <button type="button" className="layout__sidebar-logout" onClick={logout}>
                    <LogoutIcon fontSize="small"/>
                    Выйти
                </button>
            </div>
        </aside>
        <div className="layout__main">
            <header className="layout__header">
                <IconButton
                    className="layout__burger"
                    title="Меню"
                    onClick={() => setIsMenuOpen((open) => !open)}
                >
                    <MenuIcon fontSize="small"/>
                </IconButton>
                <h1 className="layout__title">{title}</h1>
                <div className="layout__user">
                    <span className="layout__user-name">{user ? user.name : ''}</span>
                    <IconButton className="layout__logout" title="Выйти" onClick={logout}>
                        <LogoutIcon fontSize="small"/>
                    </IconButton>
                </div>
            </header>
            <div className="layout__progress">
                {isLoad ? <LinearProgress/> : null}
            </div>
            <div className="layout__breadcrumbs">
                <Breadcrumbs/>
            </div>
            <main className="layout__content">{children}</main>
        </div>
    </div>;
}
